// extracted by mini-css-extract-plugin
export default {"city":"display_city__t4p2l","address2":"display_address2__be2eq"};